import { Col, Row } from "react-bootstrap";
import clsx from "clsx";
import _ from "lodash";
import React from "react";
import Helper from "../../../../utils/Helper";
import MarginCalculatorStockMovement from "../MarginCalculatorStockMovement";
function MarginCalculatorResult({
  outcome,
  getValues,
  shareMovementList,
  addNewMovement,
  handleShow,
  onClickDelete,
  onClickEdit,
}) {
  const clientInfo = _.get(outcome, ["client_info"], null);
  const summaryPosition = _.get(outcome, ["summary_position"], null);
  const availableCreditLimit = _.get(clientInfo, ["available_limit"], 0);
  const shareToSell = _.get(clientInfo, ["share_to_sell"], 0);
  const topUpCash = _.get(clientInfo, ["top_up_cash"], 0);
  const withdrawClient = _.get(clientInfo, ["withdraw_client"], 0);
  const marginValueBefore = _.get(summaryPosition, ["margin_value"], 0);
  const marginValueAfter = _.get(summaryPosition, ["margin_value_after"], 0);
  const marketValueBefore = _.get(summaryPosition, ["market_value"], 0);
  const marketValueAfter = _.get(summaryPosition, ["market_value_after"], 0);
  const outstandingAmountBefore = _.get(summaryPosition, ["outstanding_amount"], 0);
  const outstandingAmountAfter = _.get(summaryPosition, ["outstanding_amount_after"], 0);
  const positionBefore = _.get(summaryPosition, ["position"], 0);
  const positionAfter = _.get(summaryPosition, ["position_after"], 0);
  const percentum = _.get(summaryPosition, ["percentum"], 0);
  const percentumAfter = _.get(summaryPosition, ["percentum_after"], 0);
  const mof = getValues("mof");
  const totalListing = _.size(shareMovementList);
  return (
    <Col sm={12} md={12} lg={6}>
      <div className="custom-table-statement-content my-3">
        <div className="custom-table-setoff-styled mb-3">
          <h3 className="py-3 px-3 text-bold-600 general-title">Result</h3>
        </div>
        <Row className="pb-3">
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Available Credit Limit`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container ")}>
              <span className="text-bold-normal">{Helper.formattedPrice(availableCreditLimit)}</span>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Top Up Cash`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container ")}>
              <span className="text-bold-normal">{Helper.formattedPrice(topUpCash)}</span>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Max Cash Withdrawal`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container ")}>
              <span className="text-bold-normal">{Helper.formattedPrice(withdrawClient)}</span>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Share To Sell`}</h4>
            </div>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container ")}>
              <span className="text-bold-normal">{Helper.formattedPrice(shareToSell)}</span>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="d-flex flex-column">
            <div className="py-2 px-2 my-3 custom-table-setoff-styled">
              <Row>
                <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column"></Col>
                <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column">
                  <div className={clsx("custom-card-content-settlement-item-container")}>
                    <h4 className="m-0">Before</h4>
                  </div>
                </Col>
                <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column">
                  <div className={clsx("custom-card-content-settlement-item-container")}>
                    <h4 className="m-0">After</h4>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Outstanding Amount`}</h4>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(outstandingAmountBefore)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(outstandingAmountAfter)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Margin Value`}</h4>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(marginValueBefore)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(marginValueAfter)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Market Value`}</h4>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(marketValueBefore)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(marketValueAfter)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Margin Position (%)`}</h4>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(positionBefore)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div
              className={clsx("custom-card-content-settlement-item-container breakword", {
                // ['negative-number']:positionAfter > (mof * 100),
                // ['positive-number']:positionAfter <= (mof * 100)
              })}
            >
              <span className="text-bold-normal">{Helper.formattedPrice(positionAfter)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={6} xl={6} className="d-flex flex-column mt-2">
            <div className={clsx("custom-card-content-settlement-item-container")}>
              <h4 className="m-0">{`Percentum (%)`}</h4>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword")}>
              <span className="text-bold-normal">{Helper.formattedPrice(percentum)}</span>
            </div>
          </Col>
          <Col xs={4} sm={4} md={4} lg={3} xl={3} className="d-flex flex-column  mt-2">
            <div className={clsx("custom-card-content-settlement-item-container breakword", {})}>
              <span className="text-bold-normal">{Helper.formattedPrice(percentumAfter)}</span>
            </div>
          </Col>
        </Row>
      </div>
      {/* ======= For Stock Movement ====== */}
      <div className="custom-table-statement-content my-3">
        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="d-flex flex-column">
          <div className="mb-3 custom-table-setoff-styled">
            <div className={clsx("d-flex justify-content-left py-3 align-items-center")}>
              <h3 className="px-3 text-bold-600 general-title">Stock Movement</h3>{totalListing > 0 && <span>( {totalListing} )</span>}
            </div>
          </div>
          <div>
            <Row>
              <MarginCalculatorStockMovement
                  shareMovementList={shareMovementList}
                  addNewMovement={addNewMovement}
                  handleShow={handleShow}
                  onClickDelete={onClickDelete}
                  onClickEdit={onClickEdit}
              ></MarginCalculatorStockMovement>
            </Row>
          </div>
        </Col>
      </div>
      {/* ======= End for Stock Movement ====== */}
    </Col>
  );
}

export default MarginCalculatorResult;
